'use client';

import { memo } from 'react';
import { IconPlay } from '@picsart/design-system/foundation/icons/IconPlay';
import { IconImageOutline } from '@picsart/design-system/foundation/icons/IconImageOutline';

import { optimizeImageUrl } from '@/utils/optimizeImageUrl';
import { SEARCH_TEST_IDS } from '@/constants/searchConstants/testIds';
import { SearchMediaType } from '@/types/search';
import useStyles from './styles';
import type { SearchSuggestionRowProps } from './types';

const SearchSuggestionRow = ({ item, categoryLabel, onClick }: SearchSuggestionRowProps) => {
  const classes = useStyles();
  const TypeIcon = item.mediaType === SearchMediaType.Video ? IconPlay : IconImageOutline;

  return (
    <button
      type="button"
      className={classes.row}
      // A hit with no source preset has nowhere to go — keep it visible but
      // inert rather than dropping it from the result count.
      disabled={!item.presetSlug || !item.categorySlug}
      onClick={() => onClick(item)}
      data-testid={SEARCH_TEST_IDS.SUGGESTIONS_TEMPLATE_ITEM}
    >
      {/* Not `next/image`: these are CDN urls outside `remotePatterns`, and the
          CDN has already produced a thumbnail at the size asked for. */}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img className={classes.thumbnail} src={optimizeImageUrl(item.posterUrl)} alt="" aria-hidden loading="lazy" />
      <span className={classes.text}>
        <span className={classes.title}>{item.title}</span>
        {categoryLabel && (
          <span className={classes.category}>
            <TypeIcon className={classes.typeIcon} fill="currentColor" />
            {categoryLabel}
          </span>
        )}
      </span>
    </button>
  );
};

export default memo(SearchSuggestionRow);
